<template>
  <div class="trustworthiness-box" v-loading="loading" element-loading-text="拼命加载中">
    <!--查询条件区域类名 -->
    <div class="queryCondition">
      <el-form :rules="rulesFrom" :model="criteria" ref="formdatas">
        <div class="row" @click="stopProp" style="width:98%">
          <el-form-item label="姓名" prop="principalName">
            <el-input v-model="criteria.principalName" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="principalPhone">
            <el-input v-model="criteria.principalPhone" clearable></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="smsCode">
            <template>
              <el-input v-model="criteria.smsCode"></el-input>
              <el-button
                  type="primary"
                  style="margin-left: 10px"
                  @click="queryphone"
                  v-if="iscode">
                获取验证码
              </el-button>
              <el-button
                  key="index"
                  v-else
                  type="primary"
                  style="margin-left: 10px"
                  disabled>
                {{ timer }}秒后重新获取
              </el-button
              >
            </template>
          </el-form-item>
        </div>
        <div class="row" style="width:98%">
          <el-form-item label="身份证号码" prop="principalCardNum">
            <el-input v-model="criteria.principalCardNum"></el-input>
          </el-form-item>
          <el-form-item class="ml50">

            <el-button
                type="primary"
                @click="queryListByCriteria"
                icon="el-icon-search"
                :loading="loading"
            >查询
            </el-button
            >
            <el-button
                type="info"
                @click="resetQuery"
                icon="el-icon-refresh"
                :loading="loading"
            >重置
            </el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!-- table -->
    <div class="tableContent" ref="tableContent">
      <div class="ai-c mb20">
        查询结果
      </div>
      <el-table
          :data="tableData"
          ref="showTable"
          style="width: 100%"
          :height="screenHeight"
          :header-cell-style="{
					background: '#E1EEFB',
					color: '#000000',
					fontSize: '18px',
					textAlign: 'center'
				}"
          :cell-style="{
					'text-align': 'center',
					padding: '0.5rem 0',
					fontSize: '18px'
				}"
          @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column type="index" label="序号" width="70px"></el-table-column>
        <el-table-column label="技术需求名称" prop="guideName" :show-overflow-tooltip="true" min-width="80"
                         width="500px"></el-table-column>
        <el-table-column label="提交状态" prop="dataState" min-width="80"
                         :show-overflow-tooltip="true" width="180px">
          <template slot-scope="scope">
            <span v-if="scope.row.dataState==1">已提交</span>
            <span v-else>草稿</span>
          </template>
        </el-table-column>
        <el-table-column label="填报时间" prop="fillTime" min-width="100"
                         :show-overflow-tooltip="true" width="280px">
          <template slot-scope="scope">
            <span>{{ scope.row.fillTime | dateFormat('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="row-r">
        <el-pagination
            background
            layout="total, prev, pager, next, sizes"
            :total="pageTotal"
            :current-page="pageParam.pageNum + 1"
            :page-size="pageParam.pageSize"
            :page-sizes="[5, 10, 20, 50, 100]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import personService from "@/api/tabulation/tabulation"
import {dateFormat} from "@/utils/formatTime"
import {query, sendAnnoymousQuerySmsCode} from "@/api/collect/collect-api";
export default {
  data() {
    return {
        loading:false,
      headers: {"Content-Type": "multipart/form-data;charset=UTF-8"},//上传的请求头
      isshowbutton:false,//查询、重置按钮显示标志位
      screenHeight: null, //table高度
      lookisible:false,//查看弹窗
      formdata:{}, //查询
      dishonest:false,//失信受理
      dishonestform:{},//失信受理信息
      handle:false,//失信办理
      handleform:{},//失信办理信息
      options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
      tableData:[],
      pageParam: {
		  pageNum: 1,
		  pageSize: 10,
		},
        // 页码数
      pageTotal:0,
    //   列表项设置
    //   columnVisible:"",
      columnVisible: ['1', '2', '3','4','5','6','7','8','9'],
      columnLabel: [
			{
				value: '1',
				lable: '失信人姓名'
			},
			{
				value: '2',
				lable: '失信类型'
			},
			{
				value: '3',
				lable: '失信人单位名称'
			},
			{
				value: '4',
				lable: '举报行为类型'
			},
            {
				value: '5',
				lable: '是否计入失信名单'
			},
			{
				value: '7',
				lable: '是否对外公示'
			},
			{
				value: '7',
				lable: '举报人'
			},
            {
				value: '8',
				lable: '举报人所在单位'
			},
            {
				value: '9',
				lable: '审核状态'
			},
	  ],
      //新增信息
      addData:{
        ww:""
      },
    selectList: [],  // 选中的数据
    detailsform:{}, //详情数据
    examineform:{},//流程图
        //   查询条件
      criteria: {
        pageNum: 1,
        pageSize: 10,
        principalName: '',
        principalPhone: '',
        principalCardNum: '',
        smsCode: ''
      },
    iscode:true,
    timer:60,
      //非空验证
      rulesFrom: {
        principalName: [{required: true, message: "请输入姓名", trigger: "blur"},],
        principalPhone: [{required: true, message: "请输入手机号", trigger: "blur"}],
        principalCardNum: [{
          required: true,
          message: "请输入身份证号码",
          trigger: "blur"
        }
        ],
        smsCode: [{required: true, message: "请输入短信验证码", trigger: "blur"},],
      },
    };
  },
  mounted() {
    this.tableheight()
  },

  methods: {
    // 阻止冒泡
    stopProp(e) {
      e.stopPropagation();
    },
    // 给表格定义高度
    tableheight() {
        if(this.tableData.length <= 0){
            this.screenHeight = 100
        } else{
            const he = window.innerHeight
            const h = this.$refs.tableContent.getBoundingClientRect().top + 157;
            this.screenHeight = he - h ;
        }

    },
    //折叠效果-控制表格
    collapseChange(e) {
        console.log(e);
      if (e == 1) {
        this.isshowbutton = !this.isshowbutton;
        setTimeout(() => {
            this.tableheight();
        }, 300);
      } else {
        this.isshowbutton = !this.isshowbutton;
        setTimeout(() => {
            this.tableheight();
        }, 300);
      }
    },
    // 查询
    queryListByCriteria() {
      this.$refs.formdatas.validate(valid => {
        // 点确定新增校验哪些值没传
        if (valid) {
          this.loading = true
          query(this.criteria).then(res => {
            this.tableData = res.data.list
            this.pageTotal = res.data.total
            //获取表格的高度
            this.tableheight();
            this.loading = false
          }).catch(res => {
            this.loading = false
            this.$message({
              message: res.response.data.message,
              type: 'warning'
            });
          })
        }
      })
    },
    // 重置
    resetQuery(){
        this.criteria= {}
    },
    //页码变化
	handleCurrentChange(currentPage) {
		this.pageParam.page = currentPage - 1;
		this.queryListByCriteria();
	},
    //选中某条数据时
    handleSelectionChange(row) {
      this.selectList = row;     // 将选中的数据给selectList
        console.log(this.selectList,"将选中的数据给selectList")
    },
    // 发送验证码
    queryphone() {
      if (this.criteria.principalPhone.length != 11 || this.criteria.principalPhone ==  '' ) {
        this.$message({
          message: "请输入正确手机号",
          type: "warning",
        });
      } else {
        sendAnnoymousQuerySmsCode(this.criteria.principalPhone).then((res) => {
          let timer = 60;
          this.iscode = false;
          this.timeFun = setInterval(() => {
            --timer;
            this.timer = timer;
            if (timer == 0) {
              clearInterval(this.timeFun);
              this.iscode = true;
            }
          }, 1000);
        }).catch(err =>{
            this.$message({
             message: err.response.data.message,
            type: "warning",
            });
        })
      }
    },
  },
  filters: {
    dateFormat
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-collapse-item__header {
	display: flex;
	height: 78px;
	flex-wrap: wrap;
	line-height: 32px;
}
.el-collapse {
	border: 0;
}
::v-deep .el-collapse-item__arrow {
	margin: 0;
	margin-top: -23px;
}
::v-deep .queryCondition .el-form-item__label{
    width: 120px !important;
}
.trustworthiness-box {
    width: 1280px;
    margin: 0 auto;
}
::v-deep .el-select > .el-input{
    width: 190px;
}
::v-deep .el-input{
    width: 190px;
}
::v-deep .el-collapse-item__header{
    position: relative;
}
::v-deep .el-collapse-item__arrow{
    right: 30px;
}
::v-deep .el-table__empty-block {
  min-height: 20px;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
